(() => {
  // app/scripts/common/scrollTo.js
  function scrollTo(selector) {
    const targetOffsetTop = document.querySelector(selector).getBoundingClientRect().top + document.documentElement.scrollTop;
    window.scrollTo({
      top: targetOffsetTop,
      behavior: "smooth"
    });
  }

  // app/scripts/theme-custom.js
  document.body.addEventListener("click", (e) => {
    const { target } = e;
    if (target.closest(".jsScrollTo")) {
      e.preventDefault();
      scrollTo(target.closest(".jsScrollTo").href.split("#scrollTo")[1]);
    }
  });
})();
